export const formatStatus = (status: string) => {
  if (!status) return null;
  switch (status.toLowerCase()) {
    case "not_ready":
      return "pending";
    default:
      return status;
  }
};
